import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { initSentry } from '~/utils/sentry';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!, {
  onRecoverableError: (error, errorInfo) => {
    Sentry.captureException(error, {
      tags: { type: 'react_recoverable_error' },
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  },
}).render(<App />);
